import { render, staticRenderFns } from "./TicketPrioritySelect.vue?vue&type=template&id=00b2bca2&scoped=true&"
import script from "./TicketPrioritySelect.vue?vue&type=script&lang=js&"
export * from "./TicketPrioritySelect.vue?vue&type=script&lang=js&"
import style0 from "./TicketPrioritySelect.vue?vue&type=style&index=0&id=00b2bca2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b2bca2",
  null
  
)

export default component.exports